import { kodikProvider } from './kodik/KodikProvider.js'
import { kinoBdProvider } from './kinobd/KinoBdProvider.js'
import { vidriftProvider } from './vidrift/VidriftProvider.js'

const providers = new Map()

export function registerMediaProvider(provider) {
    if (!provider || !provider.id || typeof provider.search !== 'function') {
        throw new TypeError('Media provider must define id and search()')
    }
    providers.set(provider.id, provider)
    return provider
}

registerMediaProvider(kodikProvider)
registerMediaProvider(kinoBdProvider)
registerMediaProvider(vidriftProvider)

export function getMediaProvider(id) {
    return providers.get(String(id || '')) || null
}

function providerIds(value, fallback) {
    let configured = String(value || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    return configured.length ? configured : fallback
}

/* Changing an engine is intentionally a configuration change. A new provider
   only needs to implement the shared contract and be registered above. */
export function getMediaSearchChannels() {
    return [
        {
            id: 'anime',
            title: 'Аниме',
            providerIds: providerIds(process.env.VUE_APP_ANIME_PROVIDERS, ['kodik']),
        },
        {
            id: 'cinema',
            title: 'Фильмы и сериалы',
            providerIds: providerIds(process.env.VUE_APP_CINEMA_PROVIDERS, ['vidrift']),
        },
    ]
}

export function registeredMediaProviders() {
    return [...providers.values()]
}
